import { render, staticRenderFns } from "./step2.vue?vue&type=template&id=5f5fa6b7&scoped=true"
import script from "./step2.vue?vue&type=script&lang=ts"
export * from "./step2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5fa6b7",
  null
  
)

export default component.exports